import React from 'react'
import logo from './../assets/brand-logo.png';

const Footer = () => {
  return (
    <div className='footer bg-[#161C28] p-10'>
        <div className='text-center'>
          <h1 className='text-[#ffffff] text-[66px] leading-[5rem] font-medium py-20' > If you’re ready to take your<br /> business to next level</h1>
        </div>
        <div className='text-center flex justify-center form-group'>
          <input type='text' placeholder='Enter Your Email' className='py-4 pl-5 pr-32 mr-5'/>
          <a href="#trial" className='bg-[#52BD95] text-white py-4 px-5'>Start Your 15-Day Free Trial</a>
        </div>
        <div className='flex text-[#fff] justify-evenly py-28 footer-element'>
          <div>
            <img src={logo} alt='logo' className='pb-5' />
            <p>P2 09 Alhafeez Heights, Main<br /> Blvd Lahore</p>
            <p>All Rights Reserved</p>
          </div>
          <div>
              <p>Links</p>
              <p>Overons</p>
              <p>Social Media</p>
              <p>Counters</p>
              <p>Contact</p>
          </div>
          <div>
              <p>Company</p>
              <p>Terms & Conditions</p>
              <p>Privacy Policy</p>
              <p>Contact</p>
          </div>
          <div>
            <p>Get in touch</p>
            <p>P2 09 Alhafeez Heights, Main<br /> Blvd Lahore</p> 
            <p>92-300-8745564</p> 
            <p>info@techsolutions.net</p> 
          </div>
        </div>
        <div className='text-center py-3'>
          <p className='text-[#ffffff]'>© 2021 creative. All rights reserved</p>
        </div>
    </div>
  )
}

export default Footer